<template>
  <div>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <v-container>
      <v-row justify="space-between" align="center">
        <v-col cols="4">
          <v-autocomplete
            v-model="form.identificadortitulocardapio"
            :items="cardapioOptions"
            item-text="value"
            item-value="key"
            :no-data-text="cardapiosLoading ? 'Carregando dados, aguarde...' : cardapioSearch ? `Nenhuma opção encontrada com '${cardapioSearch}'` : 'Nenhuma opção carregada'"
            :search-input.sync="cardapioSearch"
            outlined
            hide-details
            loader-height="3"
            @change="carregarLancamentosCardapio"
            :disabled="loading"
            :background-color="loading ? '#f2f2f2' : null"
            label="Cardápio"
            @focus="carregaOpcoesCardapios"
          ></v-autocomplete>
        </v-col>
        <v-col cols="auto">
          <v-btn class="rounded-sm font-weight-regular" color="cyan" :dark="form.identificadortitulocardapio != '' && !loading" tile small
          :to="{ name: 'lancar-entrada-cardapio', params: { cardapio: { identificadortitulocardapio: form.identificadortitulocardapio, descricaotitulocardapio: getCardapioLabel(form.identificadortitulocardapio) } } }"
          :disabled="!form.identificadortitulocardapio || loading">Novo</v-btn>
        </v-col>
      </v-row>
  <v-rom>
          <v-col cols="3">        
                <!-- <v-card-title> -->
                  <!-- Pesquisa por ano:    -->
                  <v-text-field
                    title="Ano"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="filtra por ano, ex: 2024"
                    single-line
                  ></v-text-field>
                <!-- </v-card-title>           -->
          </v-col>
        </v-rom>

      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="cardapios"
            :items-per-page="-1"
            multi-sort
            :loading="loadingDataTable"
            loading-text="Carregando dados..."
            no-data-text="Sem dados para exibir"
            :footer-props="{itemsPerPageText: 'Linhas por página'}"
            class="elevation-1"
            fixed-header
            height="600px"
            :search="search"
          >
          <template v-slot:item.anocardapio="{ item }">
            <span v-if="!('totalizador' in item)">{{ item.anocardapio }}</span>
          </template>
          <template v-slot:item.semanacardapio="{ item }">
            <span v-if="!('totalizador' in item)">{{ getSemanaLabel(item.semanacardapio) }}</span>
          </template>
          <template v-slot:item.indicaturnocardapio="{ item }">
            <span v-if="!('totalizador' in item)">{{ getTurnoLabel(item.indicaturnocardapio) }}</span>
          </template>
          <template v-slot:item.indicarefeicaocardapio="{ item }">
            <span v-if="!('totalizador' in item)">{{ getRefeicaoLabel(item.indicarefeicaocardapio) }}</span>
          </template>
          <template v-slot:item.horacardapio="{ item }">
            <span v-if="!('totalizador' in item)">{{ item.horacardapio.slice(0,5) }}</span>
            <span v-else style="background-color: #eee;">Total do turno:</span>
          </template>
          <template v-slot:item.seg="{ item }">
            <div v-if="!('totalizador' in item)" class="d-flex justify-space-between">
              <div>
                <span v-for="prep in item.seg" :key="prep">
                  {{  preparacoes.find(i => i.identificadorpreparacao == prep.identificadorpreparacao).descricaopreparacao }}.
                </span>
              </div>
              <div>
                <v-btn icon title="Lançar composição" @click="abrirModalPreparacao(item, 'seg')">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-else style="display:flex; flex-wrap:wrap; width:100%; padding:5px;min-width:230px;">
              <div style="width:50%;" v-for="(nut, value) in calcularTotais(item, 'seg')" :key="`${nut}-${value}`">
                <span style="font-weight:bold;">{{ value }}:</span><span> {{ nut.toFixed(2) }} {{ value == 'Kcal' ? 'kcal' : value == 'Fe' || value == 'Ca' || value == 'VitC' ? 'mg' : value == 'VitA' ? 'RE' : 'g'}}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.ter="{ item }">
            <div v-if="!('totalizador' in item)"  class="d-flex justify-space-between">
              <div>
                <span v-for="prep in item.ter" :key="prep">
                  {{  preparacoes.find(i => i.identificadorpreparacao == prep.identificadorpreparacao).descricaopreparacao }}.
                </span>
              </div>
              <div>
                <v-btn icon title="Lançar composição" @click="abrirModalPreparacao(item, 'ter')">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-else style="display:flex; flex-wrap:wrap; width:100%; padding:5px;min-width:230px;">
              <div style="width:50%;" v-for="(nut, value) in calcularTotais(item, 'ter')" :key="`${nut}-${value}`">
                <span style="font-weight:bold;">{{ value }}:</span><span> {{ nut.toFixed(2) }} {{ value == 'Kcal' ? 'kcal' : value == 'Fe' || value == 'Ca' || value == 'VitC' ? 'mg' : value == 'VitA' ? 'RE' : 'g' }}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.qua="{ item }">
            <div v-if="!('totalizador' in item)"  class="d-flex justify-space-between">
              <div>
                <span v-for="prep in item.qua" :key="prep">
                  {{  preparacoes.find(i => i.identificadorpreparacao == prep.identificadorpreparacao).descricaopreparacao }}.
                </span>
              </div>
              <div>
                <v-btn icon title="Lançar composição" @click="abrirModalPreparacao(item, 'qua')">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-else style="display:flex; flex-wrap:wrap; width:100%; padding:5px;min-width:230px;">
              <div style="width:50%;" v-for="(nut, value) in calcularTotais(item, 'qua')" :key="`${nut}-${value}`">
                <span style="font-weight:bold;">{{ value }}:</span><span> {{ nut.toFixed(2) }} {{ value == 'Kcal' ? 'kcal' : value == 'Fe' || value == 'Ca' || value == 'VitC' ? 'mg' : value == 'VitA' ? 'RE' : 'g' }}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.qui="{ item }">
            <div v-if="!('totalizador' in item)"  class="d-flex justify-space-between">
              <div>
                <span v-for="prep in item.qui" :key="prep">
                  {{  preparacoes.find(i => i.identificadorpreparacao == prep.identificadorpreparacao).descricaopreparacao }}.
                </span>
              </div>
              <div>
                <v-btn icon title="Lançar composição" @click="abrirModalPreparacao(item, 'qui')">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-else style="display:flex; flex-wrap:wrap; width:100%; padding:5px;min-width:230px;">
              <div style="width:50%;" v-for="(nut, value) in calcularTotais(item, 'qui')" :key="`${nut}-${value}`">
                <span style="font-weight:bold;">{{ value }}:</span><span> {{ nut.toFixed(2) }} {{ value == 'Kcal' ? 'kcal' : value == 'Fe' || value == 'Ca' || value == 'VitC' ? 'mg' : value == 'VitA' ? 'RE' : 'g' }}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.sex="{ item }">
            <div v-if="!('totalizador' in item)"  class="d-flex justify-space-between">
              <div>
                <span v-for="prep in item.sex" :key="prep">
                  {{  preparacoes.find(i => i.identificadorpreparacao == prep.identificadorpreparacao).descricaopreparacao }}.
                </span>
              </div>
              <div>
                <v-btn icon title="Lançar composição" @click="abrirModalPreparacao(item, 'sex')">
                  <v-icon small>
                    edit
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-else style="display:flex; flex-wrap:wrap; width:100%; padding:5px;min-width:230px;">
              <div style="width:50%;" v-for="(nut, value) in calcularTotais(item, 'sex')" :key="`${nut}-${value}`">
                <span style="font-weight:bold;">{{ value }}:</span><span> {{ nut.toFixed(2) }} {{ value == 'Kcal' ? 'kcal' : value == 'Fe' || value == 'Ca' || value == 'VitC' ? 'mg' : value == 'VitA' ? 'RE' : 'g' }}</span>
              </div>
            </div>
          </template>
          <template v-slot:item.acoes="{ item }">
            <v-btn v-if="!('totalizador' in item)" icon title="Excluir" @click="excluirLancamento(item.identificadorcardapio)">
              <v-icon small>
                delete
              </v-icon>
            </v-btn>
          </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <div>
      <v-dialog v-model="dialog" persistent max-width="900px">
        <v-card>
          <v-card-title class="teal darken-1 white--text">
            <h4 class="text-h6 font-weight-medium">Compor Refeição do Dia ({{ this.diasSemana[this.diaSendoEditado] }})</h4>
            <div class="text-body-2"  v-if="itemSendoComposto !== null">
              Ano: {{ this.itemSendoComposto.anocardapio }} -
              Semana: {{ this.getSemanaLabel(this.itemSendoComposto.semanacardapio) }} -
              Turno: {{ this.getTurnoLabel(this.itemSendoComposto.indicaturnocardapio) }}  -
              Refei&ccedil;&atilde;o: {{ this.getRefeicaoLabel(this.itemSendoComposto.indicarefeicaocardapio) }} -
              Hor&aacute;rio: {{ this.itemSendoComposto.horacardapio.slice(0,5) }}
            </div>
          </v-card-title>
          <v-card-text>
             <v-container pt-9 px-2 pb-2 fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="input-wraper">
                    <v-autocomplete
                      label="Preparações"
                      outlined
                      small-chips
                      deletable-chips
                      multiple
                      color="teal"
                      no-data-text="Nenhuma preparação para exibir"
                      :items="preparacoes"
                      item-text="descricaopreparacao"
                      item-value="identificadorpreparacao"
                      v-model="preparacoesModel"
                      :disabled="loading"
                    ></v-autocomplete>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <span style="color:#b00020">{{ montagemErrorMessage }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div style="width:100%;display:flex; justify-content: end;margin-bottom: 5px;">
              <v-btn class="teal white--text mr-3 rounded-sm font-weight-regular" type="button" :loading="loading"  @click="salvarModalPreparacao()">Salvar</v-btn>
              <v-btn class="white rounded-sm font-weight-regular" type="button" :disabled="loading"  @click="cancelarModalPreparacao()">Cancelar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0">
      <div class="d-flex justify-space-between align-center">
          <span> {{ submitText }}</span>
          <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators';

import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const PreparacaoRepository = RepositoryFactory.get("preparacao");
const TituloCardapioRepository = RepositoryFactory.get("tituloCardapio");
const CardapioRepository = RepositoryFactory.get("cardapio");

import { mapGetters, mapActions } from 'vuex';

const setFormInicial = () => ({
  identificadortitulocardapio: '',
  anocardapio: '',
  refeicao: '',
});

export default {
  name: 'ElaboracaoCardapio',
  data() {
    return {
      search: '',
      acao: '',
      form: setFormInicial(),
      submitText: '',
      snackbar: false,
      msgArrayError: [],
      montagemErrorMessage: '',
      loading: false,
      loadingDataTable: false,
      itemSendoComposto: null,
      diaSendoEditado: '',
      headers: [
        {
          text: 'Ano',
          align: 'start',
          sortable: true,
          value: 'anocardapio',
          divider: true,
        },
        {
          text: 'Semana',
          align: 'start',
          sortable: true,
          value: 'semanacardapio',
          divider: true,
        },
        {
          text: 'Turno',
          align: 'start',
          sortable: true,
          value: 'indicaturnocardapio',
          divider: true,
        },
        {
          text: 'Refeição',
          align: 'start',
          sortable: true,
          value: 'indicarefeicaocardapio',
          divider: true,
        },
        {
          text: 'Horário',
          align: 'start',
          sortable: true,
          value: 'horacardapio',
          divider: true,
        },
        {
          text: 'Segunda-feira',
          align: 'start',
          sortable: false,
          value: 'seg',
          divider: true,
        },
        {
          text: 'Terça-feira',
          align: 'start',
          sortable: false,
          value: 'ter',
          divider: true,
        },
        {
          text: 'Quarta-feira',
          align: 'start',
          sortable: false,
          value: 'qua',
          divider: true,
        },
        {
          text: 'Quinta-feira',
          align: 'start',
          sortable: false,
          value: 'qui',
          divider: true,
        },
        {
          text: 'Sexta-feira',
          align: 'start',
          sortable: false,
          value: 'sex',
          divider: true,
        },
        {
          text: 'Ações',
          align: 'start',
          sortable: false,
          value: 'acoes',
          divider: true,
        },
      ],
      cardapios: [],
      cardapioOptions: [],
      semanaOptions: [
        { key: 1, value: '1º Semana' },
        { key: 2, value: '2º Semana' },
        { key: 3, value: '3º Semana' },
        { key: 4, value: '4º Semana' },
      ],
      turnoOptions: [
        { key: 'M', value: 'Matutino' },
        { key: 'V', value: 'Vespertino' },
        { key: 'N', value: 'Noturno' },
        { key: 'I', value: 'Integral' },
      ],
      refeicoesOptions: [
        { key: '1', value: 'Entrada' },
        { key: '2', value: 'Lanche' },
        { key: '3', value: 'Almoço' },
        { key: '4', value: 'Jantar' },
        { key: '5', value: 'Colação' },
      ],
      dialog: false,
      lancamentos: [],
      preparacoes: [],
      preparacoesModel: [],
      cardapiosLoading: false,
      cardapioSearch: '',
      diasSemana: {
        seg: "Segunda-Feira",
        ter: "Terça-Feira",
        qua: "Quarta-Feira",
        qui: "Quinta-Feira",
        sex: "Sexta-Feira",
      }
    };
  },
  validations: {
    form: {
      identificadortitulocardapio: { required  },
    },
  },

  computed: {
    ...mapGetters(['getAnoAtualServidor', 'getAnoInicioSistema']),
  },

  async mounted() {
    if (this.$route.params.identificadortitulocardapio) {
      this.loading = true;
      this.form.identificadortitulocardapio = this.$route.params.identificadortitulocardapio
      await this.carregaOpcoesCardapios();
      await this.carregarLancamentosCardapio(this.$route.params.identificadortitulocardapio)
      this.loading = false;
    }
    this.$Progress.finish();
  },
  methods: {
    validateRule(rule) {
      return [rule.$invalid]
    },
    calcularTotais(item, dia) {
      let cardapiosPorGrupo = this.cardapios.filter( c => {
        return item.identificadortitulocardapio == c.identificadortitulocardapio &&
        item.anocardapio == c.anocardapio &&
        item.semanacardapio == c.semanacardapio &&
        item.indicaturnocardapio == c.indicaturnocardapio &&
        !('totalizador' in c)
      })

      let totaisTurno = cardapiosPorGrupo.reduce( (totais, c) => {

        let totalCHO = 0
        let totalPTN = 0
        let totalLIP = 0
        let totalKcal = 0
        let totalFe = 0
        let totalVitA = 0
        let totalVitC = 0
        let totalCa   = 0
        c[dia].forEach(p => {
          p['composicao_preparacao'].forEach(comp => {
            totalCHO += parseFloat(comp.quantidadecarboidrato)
            totalPTN += parseFloat(comp.quantidadeproteina)
            totalLIP += parseFloat(comp.quantidadegorduratotal)
            totalKcal += parseFloat(comp.quantidadeenergia)
            totalFe += parseFloat(comp.quantidadeferro)
            totalVitA += parseFloat(comp.quantidadevitaminaa)
            totalVitC += parseFloat(comp.quantidadevitaminac)
            totalCa += parseFloat(comp.quantidadecalcio)
          })
        })

        totais['CHO'] += totalCHO
        totais['PTN'] += totalPTN
        totais['LIP'] += totalLIP
        totais['Kcal'] += totalKcal
        totais['Fe'] += totalFe
        totais['VitA'] += totalVitA
        totais['VitC'] += totalVitC
        totais['Ca'] += totalCa
        return (totais)
      }, {'CHO': 0, 'PTN': 0, 'LIP': 0, 'Kcal': 0, 'Fe': 0, 'VitA': 0, 'VitC': 0, 'Ca': 0});

      return totaisTurno
    },
    async carregarLancamentosCardapio(identificadortitulocardapio) {
      this.loading = true
      this.loadingDataTable = true
      this.cardapios = [];

      {
        const { data } = await PreparacaoRepository.buscarPreparacao();
        this.preparacoes = data.results;
      }

      const { data } = await CardapioRepository.buscarCardapiosPorTitulo(identificadortitulocardapio);
      // this.cardapioOptions.push({ value: '', key: '' })


      let cardapioSet = new Set();
      for (const cardapio of data.results) {
        cardapioSet.add(JSON.stringify({
          identificadortitulocardapio: cardapio.identificadortitulocardapio,
          anocardapio: cardapio.anocardapio,
          semanacardapio: cardapio.semanacardapio,
          indicaturnocardapio: cardapio.indicaturnocardapio,
          indicarefeicaocardapio: cardapio.indicarefeicaocardapio,
          horacardapio: cardapio.horacardapio,
          seg: [],
          ter: [],
          qua: [],
          qui: [],
          sex: [],
        }))
      }

      cardapioSet.forEach(c => this.cardapios.push(JSON.parse(c)))

      for (const cardapio of this.cardapios) {
        cardapio.identificadorcardapio = data.results.find( i =>
          i.identificadortitulocardapio == cardapio.identificadortitulocardapio &&
          i.anocardapio == cardapio.anocardapio &&
          i.semanacardapio == cardapio.semanacardapio &&
          i.indicaturnocardapio == cardapio.indicaturnocardapio &&
          i.indicarefeicaocardapio == cardapio.indicarefeicaocardapio &&
          i.horacardapio == cardapio.horacardapio
        ).identificadorcardapio


        let dias = {
          "seg": 2,
          "ter": 3,
          "qua": 4,
          "qui": 5,
          "sex": 6,
        }

        // for (const key in dias) {
        //   cardapio[key] = data.results.find(c =>
        //   c.identificadortitulocardapio == cardapio.identificadortitulocardapio &&
        //   c.anocardapio == cardapio.anocardapio &&
        //   c.semanacardapio == cardapio.semanacardapio &&
        //   c.indicaturnocardapio == cardapio.indicaturnocardapio &&
        //   c.indicarefeicaocardapio == cardapio.indicarefeicaocardapio &&
        //   c.horacardapio == cardapio.horacardapio &&
        //   c.diacardapio == dias[key]
        // ).preparacoes.map(p => p.identificadorpreparacao)
        // }

        for (const key in dias) {
          cardapio[key] = data.results.find(c =>
          c.identificadortitulocardapio == cardapio.identificadortitulocardapio &&
          c.anocardapio == cardapio.anocardapio &&
          c.semanacardapio == cardapio.semanacardapio &&
          c.indicaturnocardapio == cardapio.indicaturnocardapio &&
          c.indicarefeicaocardapio == cardapio.indicarefeicaocardapio &&
          c.horacardapio == cardapio.horacardapio &&
          c.diacardapio == dias[key]
        ).preparacoes.map(p => {
            return ({
              'identificadorpreparacao': p.identificadorpreparacao,
              'composicao_preparacao': p.composicao_preparacao
            })
          })
        }
      }

      // Monta os grupos
      let grupos = [];

      for (const cardapio of this.cardapios) {
        if (!grupos.some((el) => {
              return el.identificadortitulocardapio == cardapio.identificadortitulocardapio &&
              el.anocardapio == cardapio.anocardapio &&
              el.semanacardapio == cardapio.semanacardapio &&
              el.indicaturnocardapio == cardapio.indicaturnocardapio
            })) {
          grupos.push({
            identificadortitulocardapio: cardapio.identificadortitulocardapio,
            anocardapio: cardapio.anocardapio,
            semanacardapio:  cardapio.semanacardapio,
            indicaturnocardapio: cardapio.indicaturnocardapio,
            indicarefeicaocardapio: '',
            horacardapio: '',
            seg: [],
            ter: [],
            qua: [],
            qui: [],
            sex: [],
            totalizador: true,
          })
        }
      }


      // Coloca os grupos em suas corretas posições
      let cardapiosReversed = this.cardapios.reverse();
      grupos.forEach((g) => {
        let indexToInsert = cardapiosReversed.findIndex((c) => {
          return g.identificadortitulocardapio == c.identificadortitulocardapio &&
          g.anocardapio == c.anocardapio &&
          g.semanacardapio ==  c.semanacardapio &&
          g.indicaturnocardapio == c.indicaturnocardapio
        })
        cardapiosReversed.splice(indexToInsert, 0, g)
      })

      this.cardapios = cardapiosReversed.reverse()

      this.loading = false
      this.loadingDataTable = false
    },
    obterPreparacoes(cardapios, dia) {
    },
    async carregaOpcoesCardapios() {
      if (this.cardapioOptions.length > 0) return;
      this.cardapiosLoading = true;
      const { data } = await TituloCardapioRepository.buscarCardapios();
      for (const key of data.results) {
        this.cardapioOptions.push({ key: key.identificadortitulocardapio, value: key.descricaotitulocardapio })
      }
      this.cardapiosLoading = false;
    },

    async excluirLancamento(identificadorcardapio) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este lançamento?',
        type: 'warning',
        buttons: [
          { text: 'Sim, excluir', color: 'red', response: true },
          { text: 'Não, cancelar', color: 'grey', response: false },
        ],
      });

      if (confirmar) {
        try {
          this.loading = true;
          this.$Progress.start();

          // await new Promise(resolve => setTimeout(resolve, 1500))
          await CardapioRepository.deletarCardapio(identificadorcardapio);

          this.submitText = 'Excluído com sucesso';
          this.snackbar = true;
          this.msgArrayError = [];
          //this.cardapios = this.cardapios.filter(c => c.identificadorcardapio != identificadorcardapio);
          this.carregarLancamentosCardapio(this.form.identificadortitulocardapio)
        } catch (error) {
          const ntfExcluir = await this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        } finally {
          this.loading = false;
          this.$Progress.finish();
        }
      }
    },

    abrirModalPreparacao(item, dia) {
      this.dialog = true
      this.itemSendoComposto = item
      this.diaSendoEditado = dia
      this.preparacoesModel = this.itemSendoComposto[dia]
    },

    async salvarModalPreparacao() {
      this.loading = true;
      this.montagemErrorMessage = ''

      let i = this.cardapios.findIndex(it =>
        it.identificadortitulocardapio == this.itemSendoComposto.identificadortitulocardapio &&
        it.anocardapio == this.itemSendoComposto.anocardapio &&
        it.semanacardapio == this.itemSendoComposto.semanacardapio &&
        it.indicaturnocardapio == this.itemSendoComposto.indicaturnocardapio &&
        it.indicarefeicaocardapio == this.itemSendoComposto.indicarefeicaocardapio &&
        it.horacardapio == this.itemSendoComposto.horacardapio
      )

      let cardapioTemp = { ...this.cardapios[i] }
      cardapioTemp[this.diaSendoEditado] = this.preparacoesModel

      let dias = ['seg', 'ter', 'qua', 'qui', 'sex']

      dias.forEach( d => {
        if (d != this.diaSendoEditado) {
          cardapioTemp[d] = cardapioTemp[d].map( p => p.identificadorpreparacao)
        }
      })


      try {
        const { data } = await CardapioRepository.inserirPreparacoes(cardapioTemp);

        this.submitText = 'Dados salvos com sucesso';
        this.snackbar = true;
        this.dialog = false
        //this.cardapios[i][this.diaSendoEditado] = this.preparacoesModel
        this.carregarLancamentosCardapio(this.form.identificadortitulocardapio)
      } catch (error) {
        this.montagemErrorMessage = error.response.data.message
      } finally {
        this.loading = false
      }
    },

    cancelarModalPreparacao() {
      this.montagemErrorMessage = ''
      this.dialog = false
    },

    getLancamentoParams(lancamento) {
      return {
        ...lancamento,
        semanacardapio: this.getSemanaLabel(lancamento.semanacardapio),
        indicaturnocardapio: this.getTurnoLabel(lancamento.indicaturnocardapio),
        indicarefeicaocardapio: this.getRefeicaoLabel(lancamento.indicarefeicaocardapio),
      }
    },

    getCardapioLabel(cardapioKey) {
      const cardapio = this.cardapioOptions.find(cardapio => cardapio.key == cardapioKey)
      return cardapio ? cardapio.value : ''
    },

    getSemanaLabel(semanaKey) {
      const semana = this.semanaOptions.find(semana => semana.key == semanaKey)
      return semana ? semana.value : ''
    },

    getTurnoLabel(turnoKey) {
      const turno = this.turnoOptions.find(turno => turno.key == turnoKey)
      return turno ? turno.value : ''
    },

    getRefeicaoLabel(refeicaoKey) {
      const refeicao = this.refeicoesOptions.find(refeicao => refeicao.key == refeicaoKey)
      return refeicao ? refeicao.value : ''
    },
  },
};
</script>

<style lang="scss" scoped>
.input-block {
  width: 100%;
}
.table-siged thead tr {
  vertical-align: baseline;
}
.table-siged td {
  padding: 0px 15px;
}
</style>
